import { render, staticRenderFns } from "./AddRoleToUserRow.vue?vue&type=template&id=00561626&scoped=true&"
import script from "./AddRoleToUserRow.vue?vue&type=script&lang=js&"
export * from "./AddRoleToUserRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00561626",
  null
  
)

export default component.exports